export * from './vermerk-post-request.interface';
export * from './vermerk-post-response.interface';
export * from './vermerk-post.shapes';
